import { type FC } from 'react';
import {
  UiButton,
  UiHStack,
  UiModal,
  UiModalBody,
  UiModalContent,
  UiModalOverlay,
  UiStack,
  UiText,
  uiStyles,
} from '@/lib/ui';

export interface RemoveConfirmationProps {
  attendee: any
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isRemoveLoading: boolean
}

const RemoveConfirmation: FC<RemoveConfirmationProps> = ({
  attendee,
  isOpen,
  onClose,
  onConfirm,
  isRemoveLoading,
}) => {
  return (
    <UiModal
      onClose={onClose}
      size={'xs'}
      isOpen={isOpen}
      motionPreset={'scale'}
      isCentered={true}
    >
      <UiModalOverlay />
      <UiModalContent>
        <UiModalBody>
          <UiStack
            px={2}
            py={6}
            flexGrow={1}
            alignItems={'stretch'}
            // enableDivider={true}
            spacing={6}
            // maxW={clientWidth}
          >
            <UiText>
              Confirm to remove this attendee?
            </UiText>
            <UiStack p={4} bgColor={'blackAlpha.50'} borderRadius={uiStyles.borderRadius}>
              <UiText>{attendee.firstName} {attendee.lastName}</UiText>
              <UiText>{attendee.email}</UiText>
            </UiStack>
            <UiHStack flexGrow={1} justifyContent={'space-between'}>
              <UiButton variant={'ghost'} color={'red.500'} pl={0} py={0} onClick={onClose}>No</UiButton>
              <UiButton onClick={onConfirm} isLoading={isRemoveLoading}>Yes</UiButton>
            </UiHStack>
          </UiStack>
        </UiModalBody>
      </UiModalContent>
    </UiModal>
  );
};

export default RemoveConfirmation;
